import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-catalogs-new-product-dashboard',
  templateUrl: './catalogs-new-product-dashboard.component.html',
  styleUrls: ['./catalogs-new-product-dashboard.component.scss']
})
export class CatalogsNewProductDashboardComponent implements OnInit, OnDestroy {

  magnitudes = ['ud', 'qty', 'gr', 'kg', 'ml', 'mm', 'inch', 'oz'];
  preparations;
  getPreparationsSubscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private preparationsService: PreparationsService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getPreparations();
  }


  private getPreparations() {
    this.getPreparationsSubscription = this.preparationsService.getPreparationsList().pipe(
      tap(o => this.preparations = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-boxes', 'catalogs-page.new product', '/catalog', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.products', '/products'), new BRoute('catalogs-page.new product')]));
  }

  ngOnDestroy() {
    if (this.getPreparationsSubscription) { this.getPreparationsSubscription.unsubscribe(); }
  }
}
